// src/components/LiveContent.js
import LiveHero from './LiveHero';
import LiveInviteMessage from './LiveInviteMessage';
import LiveVenue from './LiveVenue';
import LiveTentative from './LiveTentative';
import LiveCountdown from './LiveCountdown';
import LiveUcapan from './LiveUcapan';
import LiveBottomBar from './LiveBottomBar';
import LiveIntro from './LiveIntro';
import BackgroundMusicSimple from '../BackgroundMusicSimple';
import LiveFooter from './LiveFooter';
import PhotoSlider from '../gallery/PhotoSlider';
// import PhotoGallery from '../gallery/PhotoGallery';

const LiveContent = ({
  contentRef, textColor, heroStyle, startAutoScroll, scrollYProgress, xTopStyle, xBottomStyle, playerRef,
  setPlaying, setHero, setScroll, hero, theme, walimatulurus, H2, fontP, H2size, groomName, brideName,
  weddingDate, walimatulurus2, parentName, message, groomFullname, brideFullname, location, streetAddress, city, state, zipCode,
  startTime, endTime, tentative, doa, music, ytId, ytStart, isPlaying, gift, contacts, directions,
  salamKaut, rsvp, addressData, id, musicStatus, contactsStatus, direction, countdown, rsvpStatus, moneyGift, guestBook, galleries, wishlist, onWishlist
}) => (
  <div ref={contentRef} className={`${textColor} overflow-hidden ${heroStyle}`}>
    <LiveHero {...{ startAutoScroll, scrollYProgress, xTopStyle, xBottomStyle, playerRef, setPlaying, setHero, setScroll, hero, theme, walimatulurus, H2, fontP, H2size, groomName, brideName, weddingDate }} />
    <LiveInviteMessage {...{ scrollYProgress, walimatulurus2, parentName, message, groomFullname, brideFullname, H2, fontP }} />
    <LiveVenue {...{ scrollYProgress, location, streetAddress, city, state, zipCode, startTime, endTime, weddingDate, fontP }} />
    <LiveTentative {...{ scrollYProgress, xTopStyle, xBottomStyle, hero, theme, tentative, fontP }} />
    <LiveCountdown {...{ scrollYProgress, theme, doa, weddingDate, fontP, countdown }} />
    {galleries ? <PhotoSlider {...{ cardId: id, scrollYProgress, fontP }} /> : null}
    {/* <PhotoGallery {...{ cardId: id, scrollYProgress, fontP }} /> */}
    {guestBook ? <LiveUcapan {...{ scrollYProgress, fontP }} /> : null}
    <div className="text-black">
      <LiveBottomBar {...{ id, scrollYProgress, gift, contacts, directions, weddingDate, startTime, endTime, fontP, salamKaut, rsvp, addressData, contactsStatus, direction, rsvpStatus, moneyGift, walimatulurus, groomName, brideName, wishlist, onWishlist }} />
    </div>
    {music && (
      <div>
        <LiveIntro {...{ playerRef, setPlaying, setHero, setScroll, theme, walimatulurus, H2, fontP, H2size, groomName, brideName }} />
        <BackgroundMusicSimple {...{ playerRef, setPlaying, isPlaying, videoId: ytId, videoStart: ytStart, musicStatus }} />
      </div>
    )}
    <LiveFooter />
  </div>
);

export default LiveContent;
